import { FulfilmentClient } from '@jbhi-fi/apis/src/fulfilment';
import { serviceHelper } from '../../config/service-helper';

export function getFulfilmentClient() {
  if (!serviceHelper.fulfillmentBaseURL) {
    throw new Error('Missing required environment variables for FulfilmentClient');
  }

  return new FulfilmentClient({
    fulfillmentBaseUrl: serviceHelper.fulfillmentBaseURL,
    apiKey: serviceHelper.fulfillmentApiKey,
    countryCode: window.Jbhifi.storeLocation,
  });
}
